import { IViewController } from "../../../../UserInterfaceModule/Models/IViewController";
import { ComponentService } from "../../../../UserInterfaceModule/Services/ComponentService";
import { IExpressionEvaluator } from "../../../Models/IExpressionEvaluator";
import { IExpressionEvaluatorContext } from "../../../Models/IExpressionEvaluatorContext";
import { RefreshExpression } from "../../../Models/UserInterfaces/RefreshExpression";
import { ApiServices, ApiServicesKey, DOMAIN_SERVICE_OPERATION_QUERY_KEY } from "../DomainServices/DomainServiceOperationCallExpressionEvaluator";

export class RefreshExpressionEvaluator implements IExpressionEvaluator<RefreshExpression> {
  get type(): string {
    return "UserInterface.Refresh";
  }

  async evaluate(expression: RefreshExpression, context: IExpressionEvaluatorContext): Promise<void> {
    const componentService = context.GetProperty<ComponentService>(ComponentService.KEY);
    const { queryClient } = context.GetProperty<ApiServices>(ApiServicesKey);
    const viewComponentId = componentService?.getViewComponentId();

    // Invalidate cached operation queries so the refresh bypasses staleTime
    if (queryClient && viewComponentId) {
      await queryClient.invalidateQueries({
        predicate: (query) => {
          const key = query.queryKey as any[];
          return key[0] === DOMAIN_SERVICE_OPERATION_QUERY_KEY && key[3] === viewComponentId;
        },
      });
    }

    if (!componentService) return;

    const controllers = expression.TargetComponentId
      ? [componentService.getController<IViewController>(expression.TargetComponentId)].filter(Boolean) as IViewController[]
      : componentService.getControllers<IViewController>();

    await Promise.all(controllers.map((c) => c.refresh()));
  }
}
